import { mutatorAction } from 'satcheljs';
import { publicFolderFavoriteStore, PublicFolderRequestInit } from 'owa-public-folder-favorite';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getStore from '../store/store';
export default function getPublicFolderMailboxInfo(folderId) {
    if (!getStore().has(folderId)) {
        var sourceFolder = publicFolderFavoriteStore.folderTable.get(folderId);
        var publicFolderMailboxInfo = {
            type: null,
            mailboxId: folderId,
            returnModernConversationItems: null,
            requestOptions: PublicFolderRequestInit(sourceFolder.ReplicaList != undefined
                ? sourceFolder.ReplicaList[0]
                : getUserConfiguration().SessionSettings.DefaultPublicFolderMailbox),
        };
        addToStore(folderId, publicFolderMailboxInfo);
    }
    return getStore().get(folderId);
}
var addToStore = mutatorAction('addPublicFolderMailboxInfoToStore', function (folderId, publicFolderMailboxInfo) {
    getStore().set(folderId, publicFolderMailboxInfo);
});
//# sourceMappingURL=getPublicFolderMailboxInfo.js.map